import { render, staticRenderFns } from "./ScenePixi.vue?vue&type=template&id=7ba98f08&"
import script from "./ScenePixi.vue?vue&type=script&lang=js&"
export * from "./ScenePixi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports